import React, { useState, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import CommonDialog from "../CommonDialog/CommonDialog";
import { toast } from 'react-toastify';
import { updateView, getViewById } from "../../services/viewService";
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { VIEW_TYPES } from "../../constants/Constants";

const EditView = ({ viewOpenPopup, handleClose, selectedView, getViewsData, existingViews }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (viewOpenPopup && selectedView) {
            setName(selectedView.name || '');
            setError('');
        }
    }, [viewOpenPopup, selectedView]);

    const handleChange = (e) => {
        const input = e.target.value;
        setName(input);

        const trimmedInput = input.trim().toLowerCase();

        if (!trimmedInput) {
            setError('View name is required.');
            return;
        }

        if (selectedView) {
            if (selectedView.view_type_id === VIEW_TYPES.schematic && !/^schematic.*/.test(trimmedInput)) {
                setError('View name must start with "schematic".');
                return;
            }
            if (selectedView.view_type_id === VIEW_TYPES.symbol && !/^symbol.*/.test(trimmedInput)) {
                setError('View name must start with "symbol".');
                return;
            }
            if (selectedView.view_type_id === VIEW_TYPES.stick && !/^stick.*/.test(trimmedInput)) {
                setError('View name must start with "stick".');
                return;
            }
        }

        const isDuplicate = existingViews.some(view =>
            view.name.trim().toLowerCase() === trimmedInput &&
            view.view_id !== selectedView.view_id
        );

        if (isDuplicate) {
            setError('View name already exists for this Cell.');
        } else {
            setError('');
        }
    };

    const handleUpdate = async () => {
        if (!name.trim()) {
            setError('View name is required.');
            return;
        }

            const response = await getViewById(selectedView.view_id);
            if(!response.success) return;
            var data = response.body;

            const resp = await updateView({
                name: name.trim(),
                view_id: selectedView.view_id,
                cell_id: data.cell_id
            });
            if(!resp.success) return;
            toast.success('View updated successfully.');
            getViewsData();
            handleClose();
    };

    return (
        <CommonDialog open={viewOpenPopup} onClose={handleClose} title="Edit Cell-view">
            <TextField
                fullWidth
                id="title"
                variant="outlined"
                margin="normal"
                label="View Name"
                value={name}
                onChange={handleChange}
                error={!!error}
                helperText={error}
                inputProps={{ maxLength: 20 }}
            />
            <>
                <Button variant="outlined" onClick={handleClose} startIcon={<CancelIcon />}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    className="customButtonStyle"
                    onClick={handleUpdate}
                    startIcon={<SaveIcon />}
                    disabled={!!error || !name.trim()}
                >
                    Save
                </Button>
            </>
        </CommonDialog>
    );
};

export default EditView;